import data from './data'
import Scrollspy from 'react-scrollspy'
import Nav from './Nav'
import './floating-nav.css'

const FloatingNav = () => {
  return (
    <ul id="floating__nav">
      <Scrollspy offset={-700} className='scrollspy' items={['header', 'about', /*'portfolio'*/, 'contact']} currentClassName="active">
      {/* 'services', offset={-400}*/}
        {
          data.map(item => <Nav key={item.id} item={item} />)
        }
      </Scrollspy>
    </ul>
  )
}

export default FloatingNav